<template>
  <div class="lipi">
  </div>
</template>


<style lang="scss" scoped>
</style>
<script>
export default {
  name: "lipi",

  metaInfo: {
    title: "Anvil Global Dynamics Ltd.",
    meta: [
      {
        name: "description",
        content:
          "We are a private for-profit organization mainly operating in the software services and IT industry."
      },
      {
        name: "keywords",
        content:
          "for-profit, organization, IT Industry, Software Development, Technology"
      }
    ]
  },

  mounted: function(){
      window.location = "https://lipi.live"
  }
};
</script>
